import * as types from './actionTypes';  
import offeringDetailApi from '../api/offeringDetailApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import { loadingRes } from './loadingActions';

export function doOfferingDetail(ext_id) {

  return {
    type: types.DO_OFFERING_DETAILS, 
    ext_id
  };
}

export function doOfferingDetailRes(data) {  
  return {
    type: types.DO_OFFERING_DETAILS_RES,
    data
  };
}

export function getOfferingDetail(ext_id) {
  const TOKEN = getItem('auth_token');
  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      offeringDetailApi.doOfferingDetail(ext_id).then(data => {
        dispatch(doOfferingDetailRes(data));
        dispatch(doOfferingDetailRes(null));
        dispatch(loadingRes(false));
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
}

